import axios from "axios";
import querystring from "querystring";

const headers = {
  Accept: "application/json"
};

const api = axios.create({
  baseURL: "https://integrador.app/rest/",
  // baseURL: "http://localhost/rest/",
  // baseURL: "https://beta.integrador.app/rest/",
  headers
});

const queryBuilder = params => {
  const cleanParams = {};
  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value) cleanParams[key] = value;
  });
  return querystring.stringify(cleanParams);
};

/** Retorna o objeto options usado pelo axios já com o token */
const makeOptions = authData => ({
  headers: {
    ...headers,
    ...(authData && {
      Authorization: `Bearer ${authData.token}`
    })
  }
});

export default api;
export { makeOptions, queryBuilder };
